import { Pipe, PipeTransform } from "@angular/core";

// Formats explicitly in UTC (equivalent to date-fns' "PPpp", e.g.
// "Oct 10, 2026, 12:00:00 AM"). Backend timestamps are UTC instants;
// formatting in the browser's local zone (date-fns' default) would render
// the wrong calendar day/time in any timezone other than UTC, and shifting
// the Date object by a fixed offset instead breaks across DST transitions
// since the shifted instant can land on the other side of the transition
// and pick up a different real offset than the one that was read.
const UTC_DATE_TIME_FORMAT = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
  timeZone: "UTC",
});

@Pipe({
  name: "formatDate",
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  transform(date?: string): string {
    if (!date) return "N/A";
    return UTC_DATE_TIME_FORMAT.format(new Date(date));
  }
}
